module.exports = __webpack_public_path__ + "static/media/twitter.6e8fc044.png";